// @flow
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
// import IconButton from '@material-ui/core/IconButton';
// import Icon from '@material-ui/core/Icon';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';

import Signup from '../signup/signup';
import useAuth from '../../hooks/auth';
import { SIGNUP_DIALOG } from '../../constants';

const useStyles = makeStyles((theme) => ({
	closeBtn: {
    position: 'absolute',
    top: -4,
    left: 6,
		width: 24,
    height: 24,
		padding: 0,
    color: 'white',
		'& .MuiIcon-root': {
			width: 22,
			height: 22,
			fontSize: 22,
			lineHeight: '22px',
		},
	},
	content: {
		textAlign: 'center',
		padding: '0 0 20px',
		backgroundColor: '#f05b83',
		overflowY: 'visible',
		borderRadius: '8px',
		'&:first-child': {
			paddingTop: '10px',
		},
	},
	dialog: {
		alignItems: 'start',
		marginTop: '40px',
	},
	paper: {
		width: '95%',
		margin: 0,
		borderRadius: '8px',
		overflowY: 'visible',
		'@media screen and (max-width: 664px)': {
			maxWidth: 'unset !important',
		},
	},
	machineContainer: {
		color: 'white',
	},
}));

function SignupDlg() {
	const classes = useStyles();
	const [{ signupDlg = false } = {}, , , , toggleSignupDlg] = useAuth();

	return (
		<Dialog
			maxWidth='sm'
			open={signupDlg}
			aria-label='signup dialog'
			fullWidth={true}
			classes={{ container: classes.dialog, paper: classes.paper }}
		>
			<DialogContent classes={{ root: classes.content }}>
				<header style={{position: 'relative'}}>
					<IconButton aria-label='close' className={classes.closeBtn} onClick={() => toggleSignupDlg(false)}>
						<Icon>close</Icon>
					</IconButton>
					<img src='/logo.png' alt='logo' width='90px' height='90px' className={classes.logoImg} />
				</header>
				<main className={classes.machineContainer}>
					<Signup container={SIGNUP_DIALOG} />
				</main>
			</DialogContent>
		</Dialog>
	);
}

export default SignupDlg;
